import { ReactNode } from 'react'

import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import { ButtonColor } from '@/components/view/atoms/button/Button'

import AccessCustomerModal from '@/components/container/modal/accessCustomer/AccessCustomerModal'

interface AccessCustomerModalState {
  siteId: number
  visitorId: string
}

const defaultValue = {
  siteId: 0,
  visitorId: ''
}

export const AccessCustomerModalContext = createModalContext<AccessCustomerModalState>(defaultValue)

const AccessCustomerModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<AccessCustomerModalState>(defaultValue)
  return (
    <AccessCustomerModalContext.Provider value={state}>
      {children}
      <AccessCustomerModal />
    </AccessCustomerModalContext.Provider>
  )
}

export default AccessCustomerModalProvider
